<template>
  <DialogWrapper
    class="menu-editor-dialog"
    append-to-body
    :show.sync="showDialog"
    :title="$t(`microSite.navigationPage.label.${isEdit ? 'editMenu' : 'addMenu'}`)"
  >
    <el-form class="menu-editor-form" ref="form" label-position="left" :label-width="isEn() ? '180px' : '180px'" :model="form" :rules="formRules">
      <el-form-item required class="menu-label" :label="$t('microSite.navigationPage.label.menuLabel')">
        <TinymceEditor v-if="showDialog" v-model="form.label.html" ref="tinymceEditor"></TinymceEditor>
      </el-form-item>
      <el-form-item :label="$t('microSite.navigationPage.label.hasSubMenu')">
        <SwitchButton v-model="form.hasSubMenu" :options="yesOrNoSwitchOptions"></SwitchButton>
      </el-form-item>
      <template v-if="form.hasSubMenu">
        <el-form-item class="page-layout" :label="$t('microSite.navigationPage.label.pagePadding')">
          <el-form-item :label="$t('microSite.navigationPage.label.useParent')">
            <SwitchButton v-model="form.layout.useParent" :options="yesOrNoSwitchOptions"></SwitchButton>
          </el-form-item>
          <template v-if="!form.layout.useParent">
            <el-form-item :label="$t('microSite.navigationPage.label.topPadding')">
              <el-input v-model="form.layout.topPadding" type="number">
                <template #append>px</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('microSite.navigationPage.label.horizontalPadding')">
              <el-input v-model="form.layout.horizontalPadding" type="number">
                <template #append>px</template>
              </el-input>
            </el-form-item>
          </template>
        </el-form-item>
        <el-form-item class="page-title" :label="$t('microSite.navigationPage.label.childPageTitle')">
          <el-form-item :label="$t('microSite.navigationPage.label.useParent')">
            <SwitchButton v-model="form.title.useParent" :options="yesOrNoSwitchOptions"></SwitchButton>
          </el-form-item>
          <el-form-item v-if="!form.title.useParent" :label="$t('microSite.navigationPage.label.sameWithMenuLabel')">
            <SwitchButton v-model="form.title.sameWithMenuLabel" :options="yesOrNoSwitchOptions"></SwitchButton>
          </el-form-item>
          <el-form-item v-if="!form.title.useParent && !form.title.sameWithMenuLabel" :label="$t('microSite.navigationPage.label.pageTitle')">
            <el-input v-model="form.title.text"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item v-if="form.hasSubMenu" prop="background" :label="$t('microSite.navigationPage.label.childBackground')">
          <el-form-item :label="$t('microSite.navigationPage.label.useParent')">
            <SwitchButton v-model="form.background.useParent" :options="yesOrNoSwitchOptions"></SwitchButton>
          </el-form-item>
          <ImageUpload v-if="!form.background.useParent" v-model="form.background.image" :otherTips="uploadTip"></ImageUpload>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item :label="$t('microSite.common.form.clickToJump')">
          <LinkSelector :link="form.link"></LinkSelector>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <el-button v-if="hasDeleteBtn" class="delete-btn" @click="onDelete">{{ $t('common.btn.delete') }}</el-button>
      <el-button @click="onCancel">{{ $t('common.btn.cancel') }}</el-button>
      <el-button @click="onSave">{{ $t('common.btn.save') }}</el-button>
    </template>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import SwitchButton from '../../../../components/editor/switchButton.vue'
import ImageUpload from '../../../../components/editor/imageUpload.vue'
import LinkSelector from '../../../../components/link/index.vue'
import { isEn } from '@/i18n'

export default {
  components: {
    SwitchButton,
    ImageUpload,
    LinkSelector,
    DialogWrapper,
    TinymceEditor: () => import('./tinymceEditor.vue')
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    menuPage: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    hasDeleteBtn: {
      type: Boolean,
      default: false
    }
  },
  metaInfo () {
    return {
      style: [
        { cssText: this.cssText }
      ]
    }
  },
  data () {
    return {
      isMenu: true,
      uploadTip: '',
      yesOrNoSwitchOptions: [
        { labelI18nKey: 'common.label.yes', value: true },
        { labelI18nKey: 'common.label.no', value: false }
      ],
      form: {
        label: {
          isRichText: false,
          text: null,
          html: null
        },
        link: { isActive: false },
        textColor: '#fff',
        lineColor: '#fff',
        layout: {
          useParent: false,
          topPadding: 60,
          horizontalPadding: 20
        },
        title: {
          useParent: false,
          sameWithMenuLabel: false,
          text: null
        },
        background: {
          useParent: false,
          image: null
        }
      }
    }
  },
  computed: {
    cssText () {
      if (this.show && this.form.label.isRichText) {
        return '.el-popup-parent--hidden .tox-tinymce-aux { z-index: 5000; }'
      }
      return ''
    },
    showDialog: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    formRules () {
      const rules = {
        label: [
          { validator: this.validateMenuLabel, trigger: 'blur' }
        ],
        title: [
          { validator: this.validateMenuLabel, trigger: 'blur' }
        ]
      }
      return rules
    }
  },
  created () {

  },
  methods: {
    isEn,
    onIsRichTextChange (isRichText) {
      if (isRichText) {
        this.form.label.html = this.form.label.text
      } else {
        this.form.label.text = this.$refs.tinymceEditor?.getContentAsText()
      }
      this.form.label.isRichText = isRichText
    },
    onDelete () {
      this.$emit('delete')
    },
    onCancel () {
      this.showDialog = false
    },
    async onSave () {
      let isSuccess = false
      this.$refs.form.validate((valid, failObject) => {
        isSuccess = valid
        if (!isSuccess) {
          this.$nextTick(() => {
            this.$el.querySelector('.el-form-item.is-error').scrollIntoView({ block: 'center', behavior: 'smooth' })
          })
        }
      })
      if (!isSuccess) {
        return
      }
      const form = this.form
      if (form.label.isRichText) {
        form.label.text = this.$refs.tinymceEditor.getContentAsText()
      }
      this.$emit('save', {
        label: {
          isRichText: form.label.isRichText,
          text: form.label.text,
          html: form.label.html
        },
        link: {
          isActive: !form.hasSubMenu,
          url: form.link.url,
          isInnerPage: form.link.isInnerPage,
          openNewWindow: form.link.openNewWindow
        },
        color: form.color,
        lineColor: form.lineColor,
        hasSubMenu: form.hasSubMenu,
        layout: {
          useParent: form.layout.useParent,
          topPadding: form.layout.topPadding,
          horizontalPadding: form.layout.horizontalPadding
        },
        title: {
          useParent: form.title.useParent,
          sameWithMenuLabel: form.title.sameWithMenuLabel,
          text: form.title.text
        },
        background: {
          useParent: form.background.useParent,
          image: form.background.image
        }
      })
    }
  },
  watch: {
    showDialog () {
      if (this.showDialog) {
        this.$nextTick(() => {
          this.$refs.form?.clearValidate()
        })
      }
    },
    menuPage: {
      immediate: true,
      handler () {
        const menuPage = this.menuPage || {}
        const form = {
          label: {
            isRichText: true,
            text: menuPage.label?.text,
            html: menuPage.label?.html || menuPage.label?.text || ''
          },
          link: {
            isActive: true,
            url: menuPage.link?.url,
            isInnerPage: menuPage.link?.isInnerPage || false,
            openNewWindow: menuPage.link?.openNewWindow || false
          },
          color: menuPage.color || '#fff',
          lineColor: menuPage.lineColor || '#fff',
          hasSubMenu: menuPage.menu?.isActive || false,
          layout: {
            useParent: menuPage.layout?.hasOwnProperty('useParent') ? menuPage.layout.useParent : true,
            topPadding: menuPage.layout?.topPadding || 60,
            horizontalPadding: menuPage.layout?.horizontalPadding || 20
          },
          title: {
            useParent: menuPage.title?.hasOwnProperty('useParent') ? menuPage.title.useParent : true,
            sameWithMenuLabel: menuPage.title?.hasOwnProperty('sameWithMenuLabel') ? menuPage.title.sameWithMenuLabel : true,
            text: menuPage.title?.text
          },
          background: {
            useParent: menuPage.background?.hasOwnProperty('useParent') ? menuPage.background.useParent : true,
            image: menuPage.background?.image
          }
        }
        this.form = form
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-editor-dialog {
  .menu-editor-form {
    word-break: break-word;
    .el-color-picker {
      vertical-align: middle;
    }
    .color-text {
      margin-left: 15px;
      vertical-align: middle;
    }
    .menu-label {
      .el-form-item {
        + .el-form-item {
          margin-top: 15px;
        }
      }
    }
    .page-title, .page-layout {
      .el-form-item + .el-form-item {
        margin-top: 10px;
      }
    }
  }
  .delete-btn {
    float: left;
  }
}
</style>
